module.exports = __webpack_public_path__ + "img/farzana-christopher-153.eb5e0800.jpg";